import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { insights } from '../data/insights';
import { formatDate } from '../utils/date';
export function Insights() {
  const [featured, ...rest] = insights;
  return <>
      <PageHero breadcrumb="Insights" title="Perspectives on leadership and governance." lead="Practical thinking for boards, chief executives, and senior leaders navigating succession, selection, and change." data-id="element-408" data-mp="2xuuf0tf0fyot" />
      <section className="bg-ivory" data-id="element-409" data-mp="2nxprap5inv5w">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-410" data-mp="2su6l9zzed3qw">
          <Reveal data-id="element-411" data-mp="1cgg5hvyx0r1f">
            <Link to={`/insights/${featured.slug}`} className="group grid gap-8 rounded-3xl bg-midnight-900 p-10 text-champagne-50 lg:grid-cols-12 lg:p-14" data-id="element-412" data-mp="1cfwxp82zbj14">
              <div className="lg:col-span-7" data-id="element-413" data-mp="1hdgb65rurrs0">
                <p className="text-sm text-champagne-300" data-id="element-414" data-mp="s2fx90rnjio3">
                  {featured.category} · {formatDate(featured.date)} · {featured.readTime}
                </p>
                <h2 className="mt-5 font-serif text-4xl leading-tight transition-colors duration-150 ease-out group-hover:text-champagne-200 md:text-5xl" data-id="element-415" data-mp="121dtyqz8eii6">
                  {featured.title}
                </h2>
              </div>
              <div className="flex flex-col lg:col-span-4 lg:col-start-9" data-id="element-416" data-mp="1b1ad6d2uqp5u">
                <p className="text-[16px] leading-relaxed text-champagne-100/70" data-id="element-417" data-mp="170grzrgsnogn">{featured.excerpt}</p>
                <span className="mt-auto inline-flex items-center gap-2 pt-8 text-sm font-medium text-champagne-200" data-id="element-418" data-mp="1krltz07mwsu5">
                  Read article <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-419" data-mp="1fttqd8xmnia4" />
                </span>
              </div>
            </Link>
          </Reveal>

          <ul className="mt-16 grid gap-x-10 md:grid-cols-3" data-id="element-420" data-mp="1pst0kvy1jlz8">
            {rest.map((article, i) => <li key={article.slug} className="border-t border-midnight-900/15" data-id="element-421" data-mp="1wvziljlag072" data-mpi={i}>
                <Reveal delay={i * 0.04} className="h-full" data-id="element-422" data-mp="21tso0aeroq6a">
                  <Link to={`/insights/${article.slug}`} className="group flex h-full flex-col py-8" data-id="element-423" data-mp="26ru54psmuff4">
                    <p className="text-sm text-midnight-900/55" data-id="element-424" data-mp="2bjkil4mv9jar">
                      {article.category} · {formatDate(article.date)}
                    </p>
                    <h3 className="mt-3 font-serif text-2xl leading-snug text-midnight-900 transition-colors duration-150 ease-out group-hover:text-midnight-600" data-id="element-425" data-mp="2gk8dw2i4omas">
                      {article.title}
                    </h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-midnight-900/70" data-id="element-426" data-mp="2uhoh7554nzyb">{article.excerpt}</p>
                    <span className="mt-auto pt-6 text-sm text-midnight-900/55" data-id="element-427" data-mp="v5c8i9ja92g0">{article.readTime}</span>
                  </Link>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>
      <CtaBand data-id="element-428" data-mp="sl6646abhk1k" />
    </>;
}